module.exports = __webpack_public_path__ + "static/img/hyundai-partecs.cd2edaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hyundai-partecs.jpg
// module id = BxqW
// module chunks = 0